import { AnimatePresence } from 'motion/react';
import React, { FunctionComponent, RefObject } from 'react';

import { MessageType } from '@savgroup-front-common/types';

import { EmptyPlaceHolderWithIllustration } from '../EmptyPlaceholder/EmptyPlaceHolderWithIllustration';
import { NoSearchResult } from '../Logo/NoSearchResult';

import { MENU_POSITIONS, MenuItem } from './Menu.types';
import MenuAnimator from './MenuAnimator';
import MenuContent from './MenuContent';

interface MenuitemProps {
  menuItems: MenuItem[];
  isOpen: boolean;
  onClose?: () => void;
  position?: MENU_POSITIONS | { top: string; left: string };
  dataTestId?: string;
  wrapperRef?: RefObject<any>;
  wrapperRefs?: RefObject<any>[];
  componentThemeName?: string;
  noResultsFoundMessage?: MessageType;
  minWidth?: number;
}
const Menu: FunctionComponent<React.PropsWithChildren<MenuitemProps>> = ({
  menuItems = [],
  isOpen = false,
  onClose = () => undefined,
  position,
  dataTestId,
  wrapperRef,
  wrapperRefs,
  componentThemeName,
  children,
  noResultsFoundMessage,
  minWidth,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <MenuAnimator
          position={position}
          dataTestId={dataTestId}
          componentThemeName={componentThemeName}
          minWidth={minWidth}
        >
          {children}

          {!(menuItems.length === 0 || !isOpen) && (
            <MenuContent
              menuItems={menuItems}
              onClose={onClose}
              dataTestId={dataTestId}
              wrapperRef={wrapperRef}
              wrapperRefs={wrapperRefs}
              minWidth={minWidth}
            />
          )}

          {menuItems.length === 0 && noResultsFoundMessage && (
            <EmptyPlaceHolderWithIllustration
              illustration={<NoSearchResult />}
              texts={[noResultsFoundMessage]}
            />
          )}
        </MenuAnimator>
      )}
    </AnimatePresence>
  );
};

export default Menu;
